<dx-popup width="400" height="200" [showTitle]="true" [title]="title" [(visible)]="visible" (onHidden)="onClose()">
    <div class="row mb-4">
        <div class="col-12">
            <ng-content></ng-content>
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-end">
            <ng-container *ngFor="let button of buttons">
                <dx-button class="m-2" [class]="button.cssClass" (click)="onClick(button)">
                    <i [class]="button.icon" *ngIf="button.icon; else buttonEle"></i>
                    <ng-template #buttonEle>{{button.name}}</ng-template>
                </dx-button>
            </ng-container>
        </div>
    </div>
</dx-popup>